export class Chemise{
     id : number ;
     description: string;
     archive: boolean;
     
     constructor(data:any) {
         Object.assign(this, data);
     }
 }

 export interface ChemiseCreate {
    classementId: number,
    serviceId: number,
    serviceIds: 
      number[],
    description: string,
    localisation: string,
    remarques: string,
    classementAffine: string,
    archive: boolean,
    fardeId: number
  }